var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("section", {
    staticClass: "online"
  }, [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover",
      width: "100%"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: "在线客服",
      description: "智能客服可以解决了人工成本高昂、服务效率低下、易受情绪影响等问题，24小时实时在线，让用户在同电话智能客服愉快轻松的交流中解决问题。"
    }
  })], 1), _c("div", {
    staticClass: "effective"
  }, [_c("div", {
    staticClass: "effective_main"
  }, [_c("p", {
    staticClass: "eTitle"
  }, [_vm._v("助力客服，优化人效")]), _c("FlowGrid", {
    staticClass: "eItems"
  }, _vm._l(_vm.effectives, function ({
    title,
    desc,
    icon
  }) {
    return _c("div", {
      key: title,
      staticClass: "eItem"
    }, [_c("img", {
      staticClass: "eImg",
      attrs: {
        src: icon,
        alt: icon
      }
    }), _c("h3", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
  }), 0)], 1)]), _c("div", {
    staticClass: "skill"
  }, [_c("SmartTitle", {
    attrs: {
      title: "强大功能，自如应对各种需求",
      desc: "POWERFUL, FREE TO RESPOND TO VARIOUS NEEDS"
    }
  }), _c("div", {
    staticClass: "skill_main"
  }, [_c("SmartCard", {
    attrs: {
      skills: _vm.skills
    }
  })], 1)], 1)]), _c("Cases", {
    attrs: {
      source: "aiProduct"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };